export function relatedTools() {
    document.querySelectorAll('.single-tool .s-posts-related').forEach((section) => {
        const loadMoreButton = section.querySelector('.btn-loadmore');

        if (!loadMoreButton || loadMoreButton.dataset.toptechRelatedToolsBound === 'true') {
            return;
        }

        loadMoreButton.dataset.toptechRelatedToolsBound = 'true';
        loadMoreButton.addEventListener('click', () => {
            const hiddenCards = Array.from(section.querySelectorAll('.growtype-post-single.is-hidden'));
            const visibleAmount = Number.parseInt(
                section.querySelector('.growtype-post-container')?.dataset.visiblePosts || '6',
                10
            );

            hiddenCards.slice(0, visibleAmount).forEach((card) => {
                card.classList.remove('is-hidden');
            });

            if (!section.querySelector('.growtype-post-single.is-hidden')) {
                loadMoreButton.closest('.gp-actions-wrapper')?.setAttribute('hidden', '');
            }
        });
    });
}
